/**
 * Application scripts
 * Usage: Add imports here for third party scripts, such as GSAP
 *
 * Example: import { gsap } from gsap;
 */

import { gsap } from './app/gsap';
import { MorphSVGPlugin } from './app/MorphSVGPlugin';


gsap.registerPlugin(MorphSVGPlugin);

window.addEventListener("load", () => {
	const swish = document.getElementById("svg-swish-start");
	const star = document.getElementById("svg-star");
	gsap.set(star, {scale: 0,transformOrigin:"50% 50%",visibility:"visible"});
	
	const tl = gsap
	  .timeline({
		delay: 1,
		defaults: { ease: "linear" }
	  })
	  .to(swish, {duration:.1, morphSVG: "#svg-swish-one" })
	  .to(swish, {duration:.1, morphSVG: "#svg-swish-two" })
	  .to(swish, {duration:.1, morphSVG: "#svg-swish-three" })
	  .to(swish, {duration:.1, morphSVG: "#svg-swish-end" })
	  .to(star, {duration:0.2,delay:1,scale:1});
	

})

